import SharedTimeInput from '../shared/TimeInput/SharedTimeInput';

import {
  addMissingMandatoryField,
  removeMissingMandatoryField,
  addRemark,
  removeRemark,
  updateRemark,
  addFile,
  removeFile,
} from 'reducers/homePersonalFormReducer';

import type { MessageProps } from '../shared/Message/Message.types';

interface HomeTimeInputProps {
  section: number;
  label: string;
  value: string;
  onChange: (time: string) => void;
  message?: Omit<MessageProps, 'section'> & { section?: number };
  required?: boolean;
  subLabel?: string;
  disabled?: boolean;
}

const HomeTimeInput = (props: HomeTimeInputProps) => {
  const formActions = {
    addMissingMandatoryField,
    removeMissingMandatoryField,
    addRemark,
    removeRemark,
    updateRemark,
    addFile,
    removeFile,
  };

  return (
    <SharedTimeInput
      {...props}
      formStateKey="homePersonalForm"
      formActions={formActions}
    />
  );
};

export default HomeTimeInput;
